import { render, staticRenderFns } from "./EditWorkflow.vue?vue&type=template&id=a44590c0&scoped=true&"
import script from "./EditWorkflow.vue?vue&type=script&lang=js&"
export * from "./EditWorkflow.vue?vue&type=script&lang=js&"
import style0 from "./EditWorkflow.vue?vue&type=style&index=0&id=a44590c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a44590c0",
  null
  
)

component.options.__file = "EditWorkflow.vue"
export default component.exports